<template>
  <div>
    <!-- WhatsApp Floating Button -->
    <a
        href="https://wa.me/5554992302401?text=Olá! Quero saber mais sobre os serviços da Fontes Business"
        target="_blank"
        rel="noopener noreferrer"
        class="whatsapp-float"
        :class="{ 'show': isVisible }"
        @mouseenter="showTooltip = true"
        @mouseleave="showTooltip = false"
    >
      <i class="flaticon-whatsapp"></i>
      <div class="pulse-ring"></div>
      <div class="pulse-ring pulse-ring-2"></div>
    </a>

    <!-- Tooltip -->
    <transition name="fade">
      <div v-if="showTooltip" class="whatsapp-tooltip">
        <strong>Precisa de ajuda?</strong>
        <p>Fale com nosso time agora!</p>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'WhatsAppFloat',
  data() {
    return {
      isVisible: false,
      showTooltip: false,
    };
  },
  mounted() {
    // Show button after scrolling
    window.addEventListener('scroll', this.handleScroll);

    // Show tooltip after 3 seconds
    setTimeout(() => {
      this.showTooltip = true;
      setTimeout(() => {
        this.showTooltip = false;
      }, 5000);
    }, 3000);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.isVisible = window.scrollY > 300;
    }
  }
}
</script>

<style scoped>
.whatsapp-float {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 65px;
  height: 65px;
  background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 20px rgba(37, 211, 102, 0.4);
  z-index: 1000;
  transition: all 0.3s ease;
  cursor: pointer;
  opacity: 0;
  transform: scale(0);
}

.whatsapp-float.show {
  opacity: 1;
  transform: scale(1);
}

.whatsapp-float:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 25px rgba(37, 211, 102, 0.6);
}

.whatsapp-float i {
  font-size: 32px;
  color: white;
  z-index: 2;
}

.pulse-ring {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 3px solid #25D366;
  border-radius: 50%;
  animation: pulse-ring 2s cubic-bezier(0.215, 0.61, 0.355, 1) infinite;
}

.pulse-ring-2 {
  animation-delay: 1s;
}

@keyframes pulse-ring {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(1.5);
    opacity: 0;
  }
}

.whatsapp-tooltip {
  position: fixed;
  bottom: 30px;
  right: 110px;
  background: white;
  padding: 15px 20px;
  border-radius: 12px;
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.15);
  z-index: 999;
  max-width: 250px;
}

.whatsapp-tooltip::after {
  content: '';
  position: absolute;
  top: 50%;
  right: -10px;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 10px 0 10px 10px;
  border-color: transparent transparent transparent white;
}

.whatsapp-tooltip strong {
  display: block;
  color: #1a1a1a;
  font-size: 15px;
  margin-bottom: 5px;
}

.whatsapp-tooltip p {
  margin: 0;
  color: #666;
  font-size: 13px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
  transform: translateX(20px);
}

@media (max-width: 768px) {
  .whatsapp-float {
    bottom: 20px;
    right: 20px;
    width: 60px;
    height: 60px;
  }

  .whatsapp-float i {
    font-size: 28px;
  }

  .whatsapp-tooltip {
    display: none;
  }
}
</style>